export default {"src":"https://fishbrain.com/_next/static/media/4.87d68de4.svg","height":513,"width":513,"blurWidth":0,"blurHeight":0};